import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { UserDto } from 'src/api/FiretrolApiClient';
import { userApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const ME_STALE_TIME = 5 * 60_000;

/**
 * Boot-critical identity read. `App` treats a rejection as "not signed in"
 * and redirects to /login, so the global error toast is suppressed here.
 */
export const meQueryOptions = (enabled = true): UseQueryOptions<UserDto> => ({
  queryKey: queryKeys.users.me(),
  queryFn: ({ signal }) => userApiClient.me(toCancelToken(signal)),
  enabled,
  staleTime: ME_STALE_TIME,
  retry: false,
  meta: { suppressErrorToast: true, errorContext: 'current user' },
});

/**
 * The request carries no bearer token until MSAL holds an account, and a
 * token-less 401 is joined by the boot refetch and read as "signed out",
 * which loops the app back through the login redirect. Callers gate the
 * automatic fetch on MSAL auth state; `refetch` still works while disabled.
 */
export function useMe(enabled = true) {
  return useQuery(meQueryOptions(enabled));
}
